import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Breadcrumb as AntBreadcrumb, Typography, Space } from "antd"
import { HomeOutlined } from "@ant-design/icons"

const { Title } = Typography

const Breadcrumb = props => {
  const breadcrumbItems = []

  // Add home/main title
  if (props.maintitle) {
    breadcrumbItems.push({
      title: <Link to="/">{props.maintitle}</Link>,
    })
  }

  // Add parent title
  if (props.title) {
    breadcrumbItems.push({
      title: <Link to="/">{props.title}</Link>,
    })
  }

  // Add current page (active)
  if (props.breadcrumbItem) {
    breadcrumbItems.push({
      title: props.breadcrumbItem,
    })
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        padding: "12px 0",
      }}
    >
      <Space direction="vertical" size={4}>
        <Title
          level={4}
          style={{
            margin: 0,
            fontWeight: 600,
          }}
        >
          {props.breadcrumbItem}
        </Title>
        <AntBreadcrumb
          items={[
            {
              title: (
                <Link to="/">
                  <HomeOutlined />
                </Link>
              ),
            },
            ...breadcrumbItems,
          ]}
          style={{
            fontSize: 13,
          }}
        />
      </Space>
    </div>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  maintitle: PropTypes.string,
}

export default Breadcrumb
